import { RegionSelectFieldOption } from '../m2/address'

/**
 * Map of region options by id, code and name for quick lookup.
 */
export class RegionOptionsMap {
  private readonly mappedOptions: ReadonlyMap<number | string, RegionSelectFieldOption>

  constructor(regionOptions: ReadonlyArray<RegionSelectFieldOption>) {
    this.mappedOptions = regionOptions.reduce(
      (acc: Map<number | string, RegionSelectFieldOption>, option) => {
        acc.set(option.region.id, option)
        acc.set(`c:${option.region.code}`, option)
        acc.set(`n:${option.region.name}`, option)
        return acc
      },
      new Map(),
    )
  }

  getById(id: number): RegionSelectFieldOption | undefined {
    return this.mappedOptions.get(id)
  }

  getByCode(code: string): RegionSelectFieldOption | undefined {
    return this.mappedOptions.get(`c:${code}`)
  }

  getByName(name: string): RegionSelectFieldOption | undefined {
    return this.mappedOptions.get(`n:${name}`)
  }
}
